import BaseProxy from './BaseProxy';

class Country extends BaseProxy {
    constructor(parameters = {}) {
        super('/api/v1/country', parameters);
    }

    async getAll() {
        return this.submit('get', '/all');
    }
}

export default Country;



// WEBPACK FOOTER //
// ./src/api/Country.js